import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule as NgxRouterModule } from "@obg/ngx.router";

import { PropMessageComponent } from "./prop-message.component";

@NgModule({
	imports: [TranslateModule, CommonModule, NgxRouterModule],
	exports: [PropMessageComponent],
	declarations: [PropMessageComponent],
})
export class PropMessageModule {}
